import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=2f6c3a7a&scoped=true&"
import script from "./CourseShow.vue?vue&type=script&lang=js&"
export * from "./CourseShow.vue?vue&type=script&lang=js&"
import style0 from "./CourseShow.vue?vue&type=style&index=0&id=2f6c3a7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c3a7a",
  null
  
)

export default component.exports